const constant = {
  baseurl: "https://stxavierskop.edu.in/",
};

export default constant;
